import { documentation_v0 } from './documentation_v0';
import { documentation_v1 } from './documentation_v1';

export const version_contents = {
  v0: documentation_v0,
  v1: documentation_v1,
  default: documentation_v1,
};
